import ServerError from '@/common/utils/errors/ServerError';
import { AxiosResponse } from 'axios';

export default class NotFoundError extends ServerError {
  constructor(response: Response | AxiosResponse, body: ErrorBody) {
    super(response, body, undefined, 'Not found');

    this.message = ((this.body as ErrorBody)?.error?.error?.message)
      || ((this.body as ErrorBody)?.message)
      || 'Object you are referring to is not found';
  }
}
